import { createElement } from 'react';
import './index.scss';
const multiBlockLayout = function multiBlockLayout({ style: styleOption = {}, layout, children, ...otherProps }) {
    return (createElement("div", { ...otherProps, style: { display: 'flex', padding: '4px', ...styleOption } },
        layout == 1 && createElement("div", { className: "flex width" },
            createElement("div", { style: { height: "100%" }, className: "width30 margin-right" }, children[0]),
            createElement("div", { className: "flex1" },
                createElement("div", { className: "flex1" }, children[1]),
                createElement("div", { className: "flex flex1 margin-top" },
                    createElement("div", { className: "flex1 margin-right" }, children[2]),
                    createElement("div", { className: "flex1" }, children[3])))),
        layout == 2 && createElement("div", { className: "flex width" },
            createElement("div", { style: { height: "100%" }, className: "width30 margin-right" }, children[0]),
            createElement("div", { className: "flex1" },
                createElement("div", { className: "flex flex1 margin-bottom" },
                    createElement("div", { className: "flex1 margin-right" }, children[2]),
                    createElement("div", { className: "flex1" }, children[3])),
                createElement("div", { className: "flex1" }, children[1]))),
        layout == 3 && createElement("div", { className: "flex width" },
            createElement("div", { style: { height: "100%" }, className: "width30 margin-right" }, children[0]),
            createElement("div", { className: "flex1  margin-right" },
                createElement("div", { className: "margin-bottom" }, children[1]),
                createElement("div", null, children[2])),
            createElement("div", { className: "width25" },
                createElement("div", { className: "margin-bottom" }, children[3]),
                createElement("div", null, children[4]))),
        layout == 4 && createElement("div", { className: "flex width" },
            createElement("div", { style: { height: "100%" }, className: "width30 margin-right" },
                createElement("div", { className: "margin-bottom" }, children[0]),
                createElement("div", null, children[4])),
            createElement("div", { className: "flex1" },
                createElement("div", { className: "flex1" }, children[1]),
                createElement("div", { className: "flex flex1 margin-top" },
                    createElement("div", { className: "flex1 margin-right" }, children[2]),
                    createElement("div", { className: "flex1" }, children[3])))),
        layout == 5 && createElement("div", { className: "flex width" },
            createElement("div", { className: "flex1" },
                createElement("div", { className: "flex1" }, children[1]),
                createElement("div", { className: "flex flex1 margin-top" },
                    createElement("div", { className: "flex1 margin-right" }, children[2]),
                    createElement("div", { className: "flex1" }, children[3]))),
            createElement("div", { style: { height: "100%" }, className: "width30 margin-left" },
                createElement("div", { className: "margin-bottom" }, children[0]),
                createElement("div", null, children[4]))),
        layout == 6 && createElement("div", { className: "width" },
            createElement("div", { className: "flex" },
                createElement("div", { className: "flex flex2" },
                    createElement("div", { className: "flex1 margin-right" }, children[1]),
                    createElement("div", { className: "flex1" }, children[2])),
                createElement("div", { className: "flex1 margin-left" }, children[3])),
            createElement("div", { className: "flex margin-top" },
                createElement("div", { className: "flex2" }, children[0]),
                createElement("div", { className: "flex1  margin-left" }, children[4]))),
        layout == 7 && createElement("div", { className: "width" },
            createElement("div", { className: "flex" },
                createElement("div", { className: "flex flex1 margin-right" },
                    createElement("div", { className: "flex1 margin-right" }, children[1]),
                    createElement("div", { className: "flex1" }, children[2])),
                createElement("div", { className: "flex flex1" },
                    createElement("div", { className: "flex1 margin-right" }, children[3]),
                    createElement("div", { className: "flex1" }, children[5]))),
            createElement("div", { className: "flex margin-top" },
                createElement("div", { className: "flex1 margin-right" }, children[0]),
                createElement("div", { className: "flex flex1" },
                    createElement("div", { className: "flex1 margin-right" }, children[4]),
                    createElement("div", { className: "flex1" }, children[6])))),
        layout == 8 && createElement("div", { className: "width" },
            createElement("div", { className: "flex" },
                createElement("div", { className: "flex flex2" },
                    createElement("div", { className: "flex1 margin-right" }, children[1]),
                    createElement("div", { className: "flex1" }, children[2])),
                createElement("div", { className: "flex1 margin-left" }, children[3])),
            createElement("div", { className: "flex margin-top" },
                createElement("div", { className: "flex1" }, children[0]),
                createElement("div", { className: "flex1  margin-left" }, children[4]))),
        layout == 9 && createElement("div", { className: "width" },
            createElement("div", { className: "flex margin-bottom" },
                createElement("div", { className: "flex1" }, children[0]),
                createElement("div", { className: "flex1  margin-left" }, children[4])),
            createElement("div", { className: "flex" },
                createElement("div", { className: "flex flex2" },
                    createElement("div", { className: "flex1 margin-right" }, children[1]),
                    createElement("div", { className: "flex1" }, children[2])),
                createElement("div", { className: "flex1 margin-left" }, children[3]))),
        layout == 10 && createElement("div", { className: "width" },
            createElement("div", { className: "flex margin-bottom" },
                createElement("div", { className: "flex1" }, children[0]),
                createElement("div", { className: "flex1  margin-left" }, children[4])),
            createElement("div", null, children[1])),
        layout == 11 && createElement("div", { className: "width" },
            createElement("div", null, children[1]),
            createElement("div", { className: "flex margin-top" },
                createElement("div", { className: "flex1" }, children[0]),
                createElement("div", { className: "flex1  margin-left" }, children[4]))),
        layout == 12 && createElement("div", { className: "width" },
            createElement("div", { className: "flex" },
                createElement("div", { className: "flex2" }, children[1]),
                createElement("div", { className: "flex1 margin-left" }, children[2])),
            createElement("div", { className: "flex margin-top" },
                createElement("div", { className: "flex1" }, children[0]),
                createElement("div", { className: "flex2 margin-left" }, children[4]))),
        layout == 13 && createElement("div", { className: "width" },
            createElement("div", { className: "flex" },
                createElement("div", { className: "flex1" }, children[0]),
                createElement("div", { className: "width30 margin-left" }, children[1]),
                createElement("div", { className: "width25 margin-left" }, children[2])),
            createElement("div", { className: "flex margin-top" },
                createElement("div", { className: "width25" }, children[3]),
                createElement("div", { className: "width30 margin-left" }, children[4]),
                createElement("div", { className: "flex1 margin-left" }, children[5])))));
};
export default multiBlockLayout;
